import { render, staticRenderFns } from "./ClearRejection.vue?vue&type=template&id=3ca36480&lang=pug"
import script from "./ClearRejection.vue?vue&type=script&lang=js"
export * from "./ClearRejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports